import { NgModule } from 'ng-metadata/core';
import { SourceAvatarComponent } from './source-avatar.component';
import './source-avatar.component.scss';

/**
 * @ngdoc module
 * @name mw.components.sourceAvatar
 * @description
 *
 * Stepper
 */
@NgModule({
    declarations: [ SourceAvatarComponent ]
})
export class SourceAvatarModule {}



// WEBPACK FOOTER //
// ./src/lib/components/source-avatar/source-avatar.module.ts